import { useCallback, useState } from "react";
import { RelatorioComposicaoContasQueryParams } from "core/features/relatorios/conta-com-composicoes/typings";
import { RelatorioReceitaComposicaoEvents } from "core/features/relatorios/enums/events";
import moment from "moment";
import { trackEvent } from "infra/helpers/event";
import { OperacaoEnum } from "resources/enums/conta";

export const defaultFiltroRelatorioComposicaoContas: RelatorioComposicaoContasQueryParams =
  {
    search: "",
    dataInicio: moment().startOf("month").format("YYYY-MM-DD"),
    dataFim: moment().format("YYYY-MM-DD"),
  };

function useFiltroRelatorioComposicaoContas(operacao: OperacaoEnum) {
  const [filtro, setFiltro] = useState<RelatorioComposicaoContasQueryParams>({
    ...defaultFiltroRelatorioComposicaoContas,
    tipoData: operacao === OperacaoEnum.Receita ? "movimentacao" : "vencimento",
  });

  const onChangeFiltro = useCallback(
    (_filtro: Partial<RelatorioComposicaoContasQueryParams>) => {
      trackEvent(RelatorioReceitaComposicaoEvents.Filtrar);
      setFiltro((state) => ({ ...state, ..._filtro }));
    },
    []
  );

  const onResetFiltro = useCallback(() => {
    setFiltro({
      ...defaultFiltroRelatorioComposicaoContas,
      tipoData:
        operacao === OperacaoEnum.Receita ? "movimentacao" : "vencimento",
    });
  }, [operacao]);

  return {
    filtro,
    setFiltro,
    onChangeFiltro,
    onResetFiltro,
  };
}

export default useFiltroRelatorioComposicaoContas;
